import { decorate, observable, action } from 'mobx';
import React from 'react';
import navigationStore from './sharedFiles/navigation-store';
import $ from 'jquery';
//import SideMenuStore from './sharedComponents/sideMenu/SideMenuStore';
import imageURLs from './sharedFiles/ImagesURLs';

import axios from 'axios';
import soundManagerjs from 'soundmanager2/script/soundmanager2.js';


class AppStore {
	
  	constructor(){

      this.global_errorcount=0;
      this.global_eventcount=0;
      //this.userlivestatus="offline";
      this.userlivestatus="online";
      this.pushpopp=false;
      this.currentChattingWebsite ="";
      this.chatRequests = {};
      this.inviteJoinedByOp={};
      this.chatisTransferred=false;
      this.maxconcurrentchats=0; 
      this.autoLoggedOffCounter = 0; 
      this.isAutoLoggedOff= false;
      this.requestSoundRef = React.createRef();
      this.visitorChattingwithOps={};
      this.loggedUserOnline=true
      this.requestedVisitorId="";
      this.onlineSubmenuOperators=Math.random();
      this.supervisedBy={};
      this.trafficVisitorStatusChanged= Math.random();
      this.trafficVisitorStatus=[];
         this.menuActive = window.innerWidth > 768 ? true : false;
         this.editwebsite=false;
         this.visitors={};
         this.visitorsTyping={};
         this.visitorTypingMsgChanged="";
         this.trafficMonitor={};
         this.trafficVisitorSelected = {
          "sourceStation":"",
          "accepted":false
         };
         this.visitorList=[];
         this.assignedTopics=[];
         this.chatpopuparray=[];
         this.undersupervisionvistors={};
       
         this.colourPalette = [
                                {'value':'steelBlue' , 'label': 'Steel Blue','color':'#3ba8c5'},
                                {'value':'lightSeaGreen' , 'label': 'Light Sea Green','color':'#4cb6ac'},
                                {'value':'deepPink' , 'label': 'Deep Pink','color':'#ec407a'},
                                {'value':'brown' , 'label': 'Brown','color':'#6e4c42'},
                                {'value':'navyBlue' , 'label': 'Navy Blue','color':'#234e91'},
                                {'value':'mustardYellow' , 'label': 'Mustard Yellow','color':'#e89712'},
                                {'value':'violet' , 'label': 'Violet','color':'#b968c7'},
                                {'value':'blue' , 'label': 'Blue','color':'#039be6'},
                                {'value':'darkGreen' , 'label': 'Dark Green','color':'#00887a'},
                                {'value':'green' , 'label': 'Green','color':'#4b8f4e'},
                                {'value':'grey' , 'label': 'Grey','color':'#5f7c8c'},
                                {'value':'deepSkyBlue' , 'label': 'Deep Sky Blue','color':'#64a9e0'},
                              ];
        //installed languages                      
        this.languages = [
                                { 'value':'en', 'label':'English'},
                                {'value':'ar' ,'label': 'Arabic'},
                                {'value':'bg','label':'Bulgarian'},
                                { 'value':'zh','label': 'Chinese'},
                                { 'value': 'da','label': 'Danish'},
                                { 'value': 'nl' ,'label':'Dutch'},
                                { 'value': 'fi','label':'Finnish'},
                                { 'value':'fr','label':'French'},
                                { 'value': 'de' ,'label': 'German'},
                                { 'value': 'he','label':'Hebrew'},
                                { 'value':'hu' ,'label':'Hungarian'},
                                { 'value':'it' ,'label':'Italian'},
                                { 'value':'ja','label': 'Japanese'},
                                { 'value': 'no' ,'label': 'Norwegian'},
                                { 'value': 'pl' ,'label': 'Polish'},
                                { 'value': 'pt' ,'label':'Portuguese'},
                                { 'value': 'pt_BR' ,'label':'Portuguese (Brazil)'},
                                { 'value': 'ro' ,'label': 'Romanian'},
                                { 'value': 'ru' ,'label':'Russian'},
                                { 'value': 'sr' ,'label': 'Serbian'},
                                { 'value':'es' ,'label': 'Spanish'},
                                { 'value':'sv' ,'label': 'Swedish'},
                                { 'value': 'tr' ,'label': 'Turkish'}
                           ]; 
        this.selectedLanguage=this.languages[0];      
        this.islogged=false;  
        this.isloggedout=false;
        this.colorVal='steelBlue';                   
        this.talkSessionUid=[];
        this.visitorModel={};
        this.getColor();
        this.operatorMenuActive = false;
        this.userInfo='';
        this.isAdmin=false;
        this.disableop=false;
       //for local
          // this.url = '//localhost/'; 
          // this.soundurl='//localhost';
          // this.socketUrl= '//localhost:8080/redis-chat?34=token';
          // this.assistUrl ='//localhost:8080/'
          // this.assistUrlhelp = '//localhost:8080';
          // this.resourceurl='//localhost:8080/files/resources/';
          // this.customIconurl='//localhost:8080/files/public/custom_icons/';
          // // path for icons and theme of widgets
          // this.imgpath='//localhost:8080/static/assist/';    //imgpath+"op/images/browsers/chrome.png"
          // //include broswer,flags,social icons
          // this.otherIcons='//localhost:8080/static/assist/';

      // for UAT
        this.socketUrl= '//traffic.dev.helponclick.com/redis-chat?34=token';
        this.assistUrl = '//traffic.dev.helponclick.com/';
        this.assistUrlhelp = '//traffic.dev.helponclick.com/';    
        this.url = '//app.dev.helponclick.com/';
        this.soundurl='//app.dev.helponclick.com';
        this.resourceurl= '//app.dev.helponclick.com/files/resources/';        
        this.customIconurl='//app.dev.helponclick.com/files/public/custom_icons/'; 
        this.imgpath='//traffic.dev.helponclick.com/v6.1-58/static/assist/'; 
        this.otherIcons='//traffic.dev.helponclick.com/v6.1-58/static/';
        
       //for prod
      //   this.socketUrl= '//traffic7.helponclick.com/redis-chat?34=token';
      //   this.assistUrl = '//traffic7.helponclick.com/';
      //   this.assistUrlhelp = '//traffic7.helponclick.com/';
      //   this.url = '//app.helponclick.com/';
      //   this.soundurl='//app.helponclick.com';
      //   this.resourceurl= '//app.helponclick.com/files/resources/';        
      //   this.customIconurl='//app.helponclick.com/files/public/custom_icons/';
      //   // path for icons and theme of widgets
      //   this.imgpath='//traffic7.helponclick.com/v6.1-58/static/assist/';
      //   //include broswer,flags,social icons
      //  this.otherIcons='//traffic7.helponclick.com/v6.1-58/static/';
       
        this.activeWidgets={};
        this.activeWebsites={};
        this.selectedWebisiteUid='';
        this.selectedWebisiteLogo='';
        this.selectedWebisitename='';
        this.chatautoInvitation=true;
        this.storedWidgets=[];
        this.localLanguage='';
        this.widgetForEdit="";
        this.componentDidUpdate=false;
        this.helpTourStarted=false;
        this.customImages=[];
        this.soundon_off=true;
        this.googleMapkey ="AIzaSyB5UDcRgYMaU9QXV0y2aLUumil-lqpSue8";
        this.visitorTotalSeconds = 0; 
        this.operators=[
          {
            "label": "",
            "id": "",
            "pic": "",
            "nick_name": "",
            "real_name": "",
            "admin": "",
            "email": "",
            "user_type_id": "",
            "isPasswordChanged": false,
            "user_uid": "",
            "sms_enabled": "",
            "max_chats": "",
            "online": true,
            "roleEditable": "",
            "profileImage": "",
            "image" : "",
            "selectedfile":"",
            "file": "",
          }
        ];

        this.chat_request = [
          {index:0, label:'none', value:0},
          {index:1, label:'Package 1 sound', value:imageURLs.chat_request1},
          {index:2, label:'Package 2 sound', value:imageURLs.chat_request2},
          {index:3, label:'Package 3 sound', value:imageURLs.chat_request3},
          {index:4, label:'Package 4 sound', value:imageURLs.chat_request4},
          {index:5, label:'Package 5 sound', value:imageURLs.chat_request5},
          {index:'legacy', label:'default', value:imageURLs.chat_request_default_sound}, 
        ];
        
        this.message_received = [
          {index:0, label:'none', value:0},
          {index:1, label:'Package 1 sound', value:imageURLs.msg_received_sound1},
         {index:2, label:'Package 2 sound', value:imageURLs.msg_received_sound2},
         {index:3, label:'Package 3 sound', value:imageURLs.msg_received_sound3},
         {index:4, label:'Package 4 sound', value:imageURLs.msg_received_sound4},
         {index:5, label:'Package 5 sound', value:imageURLs.msg_received_sound15},
        {index:'legacy', label:'default', value:imageURLs.msg_received_default_sound},
         
       ];
    
       this.message_sent = [
         {index:0, label:'none', value:0},
         {index:1, label:'Package 1 sound', value:imageURLs.msg_sent_sound1},
         {index:2, label:'Package 2 sound', value:imageURLs.msg_sent_sound2},
         {index:3, label:'Package 3 sound', value:imageURLs.msg_sent_sound3},
         {index:4, label:'Package 4 sound', value:imageURLs.msg_sent_sound4},
         {index:5, label:'Package 5 sound', value:imageURLs.msg_sent_sound5}, 
       ];
       
       this.new_visitor = [
         {index:0, label:'none', value:0},
         {index:1, label:'Package 1 sound', value:imageURLs.msg_received_sound1},
         {index:2, label:'Package 2 sound', value:imageURLs.msg_received_sound2},
         {index:3, label:'Package 3 sound', value:imageURLs.msg_received_sound3},
         {index:4, label:'Package 4 sound', value:imageURLs.msg_received_sound4},
         {index:5, label:'Package 4 sound', value:imageURLs.msg_received_sound5},
         {index:'legacy', label:'default', value:imageURLs.new_visitor_default_sound},
       ];
       
      this.tourcurrent_step=0;
      this.assistedit=false;
      this.lodasound=0;
      this.loopcountsound=0;
      this.chatacceptalert=false;
      this.acceptedvistorlist=[];
      soundManagerjs.soundManager.setup({ debugMode: false });
      this.monthly_chat_enable_count=0;
    }
 
  getLanguageTrans = (key) => {
    
    let searchKey = key;
    if(!key)
    return;
    //get custom lang if set by user for selected langauge
    let foundValue = this.getCustomLanguage(key);
    
    if(foundValue){
      //if custom lang found 
      return foundValue;
    }

    if(this.localLanguage != null){
    foundValue = this.localLanguage[Object.keys(this.localLanguage).find(key => key.toLowerCase() === searchKey.toLowerCase())];

    }
    if(this.localLanguage == null){
      return key;
    }
    // (this.localLanguage[key] && this.localLanguage[key][1] !== null)
    else if(foundValue != undefined && foundValue[1] !== null) {
         //this.localLanguage[key][1]==0
        if(foundValue[1]==undefined || foundValue[1].length==0)
        return key;

      return foundValue;
    } else {
      return key }

  } 

  getCustomLanguage(key){
    //set custom lang for selected langauge
    if( !this.userInfo.usersmodel){
      return key ;
    }
    let languageOfuser =  this.userInfo.usersmodel.lang;
    let self = this;
    let found='';
    this.userInfo.allcustomLanguage.map(function(language,languageIndex) {
     if(language.lang === languageOfuser) {
       if(language.data!=""){
        const data =  JSON.parse(language.data);
        for(let label in data){
          if(label.toLowerCase() === key.toLowerCase()){
            found = data[label][1];
            break;
          }
         }
        }
        }
      }); 
     return found;
   }
   downgrade(data){
    let self=this;
    axios({
      method: 'POST',
      url: self.url + 'downgrade.json',
      headers: { 'content-type': 'application/json' },
      data:self.userInfo.usersmodel,
    }).then(result => {
      
    });
   }
   autoLogout =(logoutTime) =>{ 
    if(!logoutTime)
      return;
      
    let time = new Date();
    let hrs = ("0" + time.getHours()).slice(-2);
    let min =    ("0" + time.getMinutes()).slice(-2); 
    let sec =("0" + time.getSeconds()).slice(-2);

    if(logoutTime.indexOf(":") == -1)
    return;

    var a = Number(logoutTime.split(":")[0]);
    var b = Number(hrs);
    var c= Number(logoutTime.split(":")[1]);
    var d= Number(min);
    let hr,m;

    if(a<b){	
        hr= 24-(b-a);
        m= d-c;
        hr= m <0 ? hr-1 :hr;
        m= m<0 ? 60+m : m;
      }
      else if(a>b){
        m = c-d;
        hr = a-b;
        hr = m < 0 ? hr-1 : hr;
        m = m < 0 ? m+60:m; 
      }
      else
      {
        //if a==b
        hr=0;
        m=c-d;
        if(m<0){
          hr=23;
        }
        m= m<0 ? 60+m : m;
      }
    
    //convert to seconds
    let remainingTime = (hr * 60 * 60) + (m * 60);
   if(remainingTime==0)
     return;

     let currentSeconds = new Date().getSeconds();
     remainingTime = (remainingTime-currentSeconds)*1000;
     remainingTime = remainingTime-30000; //show autologoff popup before 30 seconds
     
    setTimeout(() =>{
      // const unsetData=true;
     this.isAutoLoggedOff=true;
      this.showSessionOverPopup = true;
    },remainingTime)
  

   }

  getLangLabel = (value)  =>{
    let langauge = this.languages.filter(function(lang) {
      return lang.value == value;
     })
  
   if(langauge.length == 0){
      //if lang not found
      return value;
    }
   return langauge[0].label;
  }

  setLanguage(selectedOption){
       this.selectedLanguage = selectedOption;  
   }


  logout = async (unsetData=false) => {  
 
    let userstatus="offline";
    let user =  this.userInfo.usersmodel;

    try{
      this.setofflineOnlineop(this.userInfo.alloperators,user,userstatus); 
      await this.clientRef.sendMessage("/app/onOpdisconnect", JSON.stringify({"operatorUid":user.user_uid,"account_id":user.account_id}));
    }  
    catch(error){
      console.log(error);
    } 

    if(!unsetData){
      try{ 
          let now = new Date();
          // const currentTime = Math.floor((now.getTime() + (now.getTimezoneOffset() * 60000))/1000);
          const currentTime = Math.floor((now.getTime())/1000);
          const user = this.userInfo.usersmodel;
          const userRole = user.user_type_id == 3 ? 'admin':'operator';
          
          let visitorIds = Object.keys(this.visitors);

            for(let visitorId of visitorIds){
              let opMsg = {
                  id: '', type: "opsMsg", role:userRole,userUid: visitorId, operatorUid:user.user_uid,  message: "",
                  creationTime: currentTime, hostname: 'ip', sourceStation: visitorId, chatStatus: "opQuit",
                  account_uid:user.account_uid, name: user.nick_name, email: user.email
                  , fileName: "", originalFileName: "",fileSize:"", targetStation: '/topic/' + visitorId
              }
              
              this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg));

          }
 
         await  this.handleQuitchat(visitorIds)
        }
        catch(err){
          console.log(err)
        }
           
    }
 
      let self=this; 
          self.isloggedout = unsetData ? false : true;
          self.userInfo.usersmodel.unsetData=self.isloggedout;
        axios({
          method: 'POST',
          url: self.url + 'logOutuser.json',
          headers: { 'content-type': 'application/json' },
          data:self.userInfo.usersmodel,
        }).then(result => {  
        
          if(!unsetData){
   
                  localStorage.clear();
                  window.location.href=self.url;
                  self.userInfo = "";
                  localStorage.setItem("soundOnorOff",1);
          }
                
          this.assignedTopics = [];
          self.isloggedout = false; 
        }).catch((error) => {
            localStorage.clear();
            self.userInfo = "";
            localStorage.setItem("soundOnorOff",1);
            window.location.href=self.url;
        });     
  }

  beforeunloadlogout =() =>{
 
    let trafficVisitorStatus = this.trafficVisitorStatus.map(function (el) { return el.sourceStation; });
    let visitorIds = Object.keys(this.visitors)
    this.userInfo.usersmodel.trafficVisitorStatus=trafficVisitorStatus;
    this.userInfo.usersmodel.visitors=visitorIds;
    this.userInfo.usersmodel.unsetData=true;
    axios({
      method: 'POST',
      url: this.url + 'beforeunloadlogOutuser.json',
      headers: { 'content-type': 'application/json' },
      data:this.userInfo.usersmodel,
    }).then(result => {  

    }).catch((error) => { 

    }); 
  }
  
  getIp=() => {
    var Address6 = require('ip-address').Address6;
    var address = new Address6('2001:0:ce49:7601:e866:efff:62c3:fffe');
    address.isValid(); // true
    var teredo = address.inspectTeredo();
    return teredo.client4;
  }
   
    generateUid=() => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {var r = Math.random()*16|0,v=c=='x'?r:r&0x3|0x8;return v.toString(16);});
         
    }
    getColor(){
      // this.colorVal = localStorage.getItem('dashboardColor');
      let colorVal = this.colorVal;
      let self = this;
      this.selectedColor = this.colourPalette[0];
      this.colourPalette.map(function(color, colorIndex){
        if(color.value === colorVal) {
          self.selectedColor = color;
        }
      });
    }

     toggleMenu(event){
	    this.menuActive = !this.menuActive;
	  }

     closeSubmenu(event) {
        this.menuActive = false;
    }

    navigate(link){
        this.menuChanged = link;
        navigationStore.push(link);
    }

    setColor(selectedcolor){
      //localStorage.setItem('dashboardColor', selectedcolor.value);
      this.selectedColor = selectedcolor;
    }
      

    
  handleQuitchat = async (visitorIdArray) => {
    await axios({
      method: 'POST',
      url: this.url + 'handlequitchat.json?visitorId=' + visitorIdArray,
      headers: { 'content-type': 'application/json' }
    }).then(result => {

      // console.log(result)
      this.global_errorcount=0;
    }).catch((error) => {
      //this.logout();
      console.log(error);
      console.log("error count :"+this.global_errorcount);
    //this.logout()
      this.global_errorcount=this.global_errorcount+1;
      if(this.global_errorcount>20){
      // this.logout();
      }

    });

    await this.checkconcurrent_chats();
  }

   removeFromTraffic = async ( visitorIdArray) =>{

    await axios({
			method: 'POST',
			url: this.url + 'removeTrafficVisitor.json?visitorId='+visitorIdArray,
            headers: { 'content-type': 'application/json' }
	 	  }).then(result => {            
        if(result.data != null){
          let trafficData = [];
          for(let i=0; i< this.trafficVisitorStatus.length; i++){
              if(!visitorIdArray.includes(this.trafficVisitorStatus[i].sourceStation)){
                trafficData.push(this.trafficVisitorStatus[i]);
              }
          }
        }else{
          this.trafficVisitorStatus = [];
        }
        this.global_errorcount=0;
		}).catch((error) => {
		//	this.logout();
      console.log(error);
      console.log("error count :"+this.global_errorcount);
    //this.logout()
      this.global_errorcount=this.global_errorcount+1;
      if(this.global_errorcount>20){
      // this.logout();
      }
        })
   }


   removeFile_untilChatSession = async (visitorIdArray) =>{
     await axios({
      method: 'POST',
      url: this.url + 'removeTransferredFile.json?visitorId='+visitorIdArray,
            headers: { 'content-type': 'application/json' }
      }).then(result => {            
        
        // console.log(result)
        this.global_errorcount=0;
    }).catch((error) => {
      //this.logout();
      console.log(error);
      console.log("error count :"+this.global_errorcount);
    //this.logout()
      this.global_errorcount=this.global_errorcount+1;
      if(this.global_errorcount>20){
      // this.logout();
      }
        })
 }


    generateAssistCode(uid){
      
      if(!uid){
         return "";
      }
      let trafficurl = this.assistUrl;
      let private_label= false;
			let url = (trafficurl + 'assist') + '?c=' + uid;
			let scriptCode = "<script type='text/javascript'>(function() {\n"
			+ "\tvar po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;\n"
			+ "\tpo.src = '" + url + "';\n"
			+ "\tvar s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);\n"
			+ "})();</script>";

			// let hasIcon = _.indexOf(this.record.get('modes'), HelpOnClick.shared.AssistModes.ICON) !== -1;
			// if (hasIcon) {
			// 	scriptCode = "<span id='__livechat-assist' style='display: none'></span>\n" + scriptCode;
			// }
			return private_label
				? "<!-- LiveChat -->\n" + scriptCode + "\n<!-- /LiveChat -->"
				: "<!-- HelpOnClick -->\n" + scriptCode + "\n<!-- /HelpOnClick -->";
    }
    
     // Fetching Department and Operator DropDown Data based on website
     dptoptforwebiste= async(uid="") =>{   
      this.componentDidUpdate=false;
     await axios({
        method: 'POST', 
        url: this.url+'dptoptforwebiste.json',
        headers: { 'content-type': 'application/json' },
        data:{"website_uid": this.selectedWebisiteUid,"department_uid":uid},
      }).then(result=> {  
        if(result.data.length==1){
          if(result.data.logoutstatus==1){
            this.logout();
          }
          }
              let depts = result.data.departmentsmodel;             
              let alldept = {"label":"All Departments","value":"","department_uid":""};
              depts.splice(0, 0,alldept);       
              for (let x in depts)
              { 
                if(x>0) {
                depts[x].label = depts[x].name;
                depts[x].value= depts[x].department_uid;       
                depts[x].department_uid =  depts[x].department_uid;
                }      
              }        
              
              let  chat_redirect_dept=depts;
              let opt = result.data.usersmodel;  
              let allopt = {"label":"All Operators","value":"","user_uid":""}; 
              opt.splice(0, 0,allopt);   
              
              for (let x in opt)
              { 
                if(x>0) {
                  opt[x].label = opt[x].nick_name;
                  opt[x].value= opt[x].user_uid;       
                  opt[x].user_uid = opt[x].user_uid;
                }      
              }         
              
              this.deptOps = {"allDept":chat_redirect_dept,"allOps":opt}
              this.global_errorcount=0;
            }).catch((error) => {
               // this.logout();
                console.log(error);
                  console.log("error count :"+this.global_errorcount);
                //this.logout()
                  this.global_errorcount=this.global_errorcount+1;
                  if(this.global_errorcount>20){
                  // this.logout();
                  }
             }); 
    }
//croped Image Base64stringto  file conversion
    base64StringtoFile(base64String, filename) {
      var arr = base64String.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
    //croped image Download function
    downloadBase64File(base64Data, filename) {
      //const blobUrl = window.URL.createObjectURL(base64Data); 
      var element = document.createElement('a')
      element.setAttribute('href', base64Data)
      element.setAttribute('download', filename)
      element.setAttribute('crossOrigin','Access-Control-Allow-Origin')
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    }
    
    // converting imageurl to base64string
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    }

    getuploadimageurl = (image) =>{
 
      var file = image.name;
      var ext = file.lastIndexOf(".");
      var slice = file.slice(ext + 1, file.length);
    
      if(slice=="png" || slice=="jpeg" || slice=="jpg" || slice=="gif"|| slice=="bmp"){
      return	 URL.createObjectURL(image); 
      }
      else {
        return this.otherIcons + "images/fileIcons/" + slice+".png"; 
        }
   
    }
  
    getimageurl = (image,component="") =>{
     
      var file = image; 
      var ext = file.lastIndexOf(".");
      var slice = file.slice(ext + 1, file.length);
      if(slice=="png" || slice=="PNG" || slice=="jpeg" || slice=="JPEG" || slice=="jpg" || slice=="JPG" || slice=="GIF" || slice=="gif" || slice=="bmp" || slice=="BMP"){
        if(component==="chat")
        return image;
       
        else
         return	this.resourceurl + this.userInfo.accountsmodel.account_uid + "/canned_response/" + image; 
      }else {
        
      return	this.otherIcons + "images/fileIcons/" + slice+".png"; 
      }
    }

    setUserStatus_Topics =() => {
      const user = this.userInfo.usersmodel;
      this.isOwner = user.is_owner;
      this.ownerEmail = user.ownerEmail;
  
      if(user.user_type_id == 3)
          this.isAdmin =true;

          this.islogged = true; 

      //pass useruis param for online time in redis
        this.socketUrl = this.socketUrl+"&userUid="+user.user_uid;
       
      //set auto logout time
       this.autoLogout(user.auto_logoff)  
        //set assigned website, depts for logged user and set user_uid too
        this.assignedTopics = [];
        for(let i in  this.userInfo.websitesforOp){
           this.assignedTopics.push('/topic/'+ this.userInfo.websitesforOp[i].website_uid)
        }
           this.assignedTopics.push('/topic/'+ this.userInfo.usersmodel.user_uid);

       //set assigned departments for logged user
       for(let i in  this.userInfo.deptForOp){
           this.assignedTopics.push('/topic/'+ this.userInfo.deptForOp[i].department_uid);
     }  
     //console.log(JSON.stringify(this.assignedTopics))
    
    }
    
    setofflineOnlineoplogin=(alloperators,user,status)=>{  
      //send online,offline status to all admins
      const currentTime = this.getcurrentUtcTime();
      const liveStatus = status;
  
      let opMsg =  {id:'',system_msg:true, type:"",email:user.email, role:"operator", message:"",creationTime: currentTime,
                    sourceStation:"",chatStatus:liveStatus} 
      //send status to Admin
      for(let i=0; i< alloperators.length; i++){ 
        //if(alloperators[i].user_type_id === 3){  //previously this condition was there , dont remeber why
        if(alloperators[i].user_uid !== user.user_uid && alloperators[i].user_live_status=="online"){
            opMsg.targetStation ='/topic/'+ alloperators[i].user_uid;
            opMsg.operatorUid = user.user_uid;  
            this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg));  
          }
      }
      //send status to all visitor
      setTimeout(()=>{
      // console.log("send status to all visitor");
      // console.log(this.trafficVisitorStatus);
    for(let visitor  of  this.trafficVisitorStatus){
        opMsg.targetStation ='/topic/'+ visitor.sourceStation;
        opMsg.operatorUid = user.user_uid;

        this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg)); 
      }
    },3000);

   }

    setofflineOnlineop=(alloperators,user,status)=>{  
      //send online,offline status to all admins
      const currentTime = this.getcurrentUtcTime();
      const liveStatus = status;
  
      let opMsg =  {id:'',system_msg:true, type:"",email:user.email, role:"operator", message:"",creationTime: currentTime,
                    sourceStation:"",chatStatus:liveStatus} 
      //send status to Admin
      for(let i=0; i< alloperators.length; i++){ 
        //if(alloperators[i].user_type_id === 3){  //previously this condition was there , dont remeber why
        if(alloperators[i].user_uid !== user.user_uid && alloperators[i].user_live_status=="online"){
            opMsg.targetStation ='/topic/'+ alloperators[i].user_uid;
            opMsg.operatorUid = user.user_uid;  
            this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg));  
          }
      }
      //send status to all visitor
      // console.log("send status to all visitor");
      // console.log(this.trafficVisitorStatus);
    for(let visitor  of  this.trafficVisitorStatus){
        opMsg.targetStation ='/topic/'+ visitor.sourceStation;
        opMsg.operatorUid = user.user_uid;

        this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg)); 
      }
      
   }

    

   getCurrenChat = async(sourceStation) => {
    
    const visitorId = sourceStation;
    console.log(sourceStation);
    if(!visitorId)
    return ;

    await axios({
        method: 'POST',
        url: this.url + 'getcurrentChat.json?csId='+visitorId,
        headers: { 'content-type': 'application/json' }
    }).then(result => {
      //  console.log(JSON.stringify(result.data))
     //result.data = {"csId":"c1595665022293","assistUid":null,"websocketSessionId":"ymvnsvvw","webSessionId":null,"disconnectionTime":0,"connectionTime":0,"notified":false,"allChatMsg":[{"userUid":"c1595665022293","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"visitor","message":"","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"Browsing","name":"","email":"","acceptedBy":"","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645225,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{}","system_msg":true,"screenSize":"1366X768","language":"en","staff_message":false,"visitorEnvironment":{"accountUid":null,"userUid":null,"ipAddress":"0:0:0:0:0:0:0:1","cc":null,"browser":"Firefox-78.0","os":"Windows","userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:78.0) Gecko/20100101 Firefox/78.0","screenSize":null,"refererUrl":null},"fileSize":""},{"userUid":null,"session_uid":null,"assist_uid":null,"role":"operator","message":"","hostname":"DESKTOP-9JH62RU","sourceStation":"","targetStation":"/topic/c1595665022293","chatStatus":"offline","name":null,"email":null,"acceptedBy":null,"websiteUid":null,"departmentUid":null,"pageTitle":null,"formUrl":null,"responseUid":null,"fileName":null,"account_uid":null,"originalFileName":null,"ipAddress":null,"operatorUid":"50b6b9c0-ac00-4d8c-a833-7393b86abfd4","creationTime":1595645244,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":null,"system_msg":true,"screenSize":null,"language":null,"staff_message":false,"visitorEnvironment":null,"fileSize":null},{"userUid":"-2","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"virtual","message":"Hello, I'm a Virtual Agent. I am here to help you, ask me a question.","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"Virtual Agent","email":"","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645248,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":true,"screenSize":"1366X768","language":null,"staff_message":false,"visitorEnvironment":null,"fileSize":""},{"userUid":"c1595665022293","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"visitor","message":"hey","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"thak","email":"not provided","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645252,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":false,"screenSize":"1366X768","language":"en","staff_message":false,"visitorEnvironment":{"accountUid":null,"userUid":null,"ipAddress":"0:0:0:0:0:0:0:1","cc":null,"browser":"Firefox-78.0","os":"Windows","userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:78.0) Gecko/20100101 Firefox/78.0","screenSize":null,"refererUrl":null},"fileSize":""},{"userUid":"-2","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"virtual","message":"Could you specify your inquiry? Please note, that I can only answer questions regarding our products, and spelling affects the results. </br> <a>How it works</a>","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"Virtual Agent","email":"","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645252,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":false,"screenSize":"1366X768","language":null,"staff_message":false,"visitorEnvironment":null,"fileSize":""},{"userUid":"c1595665022293","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"visitor","message":"lol","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"thak","email":"not provided","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645257,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":false,"screenSize":"1366X768","language":"en","staff_message":false,"visitorEnvironment":{"accountUid":null,"userUid":null,"ipAddress":"0:0:0:0:0:0:0:1","cc":null,"browser":"Firefox-78.0","os":"Windows","userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:78.0) Gecko/20100101 Firefox/78.0","screenSize":null,"refererUrl":null},"fileSize":""},{"userUid":"-2","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"virtual","message":"Could you specify your inquiry? Please note, that I can only answer questions regarding our products, and spelling affects the results. </br> <a>How it works</a>","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"Virtual Agent","email":"","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645257,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":false,"screenSize":"1366X768","language":null,"staff_message":false,"visitorEnvironment":null,"fileSize":""},{"userUid":"c1595665022293","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"visitor","message":"no","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"thak","email":"not provided","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645260,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":false,"screenSize":"1366X768","language":"en","staff_message":false,"visitorEnvironment":{"accountUid":null,"userUid":null,"ipAddress":"0:0:0:0:0:0:0:1","cc":null,"browser":"Firefox-78.0","os":"Windows","userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:78.0) Gecko/20100101 Firefox/78.0","screenSize":null,"refererUrl":null},"fileSize":""},{"userUid":"-2","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"virtual","message":"If you have any questions left, please leave your contact details and our representative will contact you shortly.","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chat","name":"Virtual Agent","email":"","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645260,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":false,"screenSize":"1366X768","language":null,"staff_message":false,"visitorEnvironment":null,"fileSize":""},{"userUid":null,"session_uid":null,"assist_uid":null,"role":"operator","message":"","hostname":"DESKTOP-9JH62RU","sourceStation":"","targetStation":"/topic/c1595665022293","chatStatus":"online","name":null,"email":null,"acceptedBy":null,"websiteUid":null,"departmentUid":null,"pageTitle":null,"formUrl":null,"responseUid":null,"fileName":null,"account_uid":null,"originalFileName":null,"ipAddress":null,"operatorUid":"50b6b9c0-ac00-4d8c-a833-7393b86abfd4","creationTime":1595645271,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":null,"system_msg":true,"screenSize":null,"language":null,"staff_message":false,"visitorEnvironment":null,"fileSize":null},{"userUid":"c1595665022293","session_uid":null,"assist_uid":"046f2fe3-b5dd-416b-a3df-24f7a7db3b8c","role":"visitor","message":" enters chat","hostname":"DESKTOP-9JH62RU","sourceStation":"c1595665022293","targetStation":"/topic/50b6b9c1-edf8-4c0f-803b-7393b86abfd4","chatStatus":"chatRequest","name":"thak","email":"not provided","acceptedBy":"-2","websiteUid":"50b6b9c1-edf8-4c0f-803b-7393b86abfd4","departmentUid":"","pageTitle":"","formUrl":"http://localhost:5000/chat","responseUid":null,"fileName":"","account_uid":"50b6b9c06000416891e47393b86abfd4","originalFileName":"","ipAddress":"","operatorUid":"","creationTime":1595645308,"started":0,"ended":0,"chatLength":0,"account_id":0,"prechatfields":"{\"0\":{\"name\":\"email\",\"value\":\"not provided\",\"type\":\"email\"},\"1\":{\"name\":\"realName\",\"value\":\"thak\",\"type\":\"name\"},\"2\":{\"id\":\"noweb_new_department\",\"name\":\"I Agree to suguna affka <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/terms-of-use/\\\" target=\\\"_blank\\\">Terms &amp; conditions      </a>, <a style=\\\"color:blue;\\\" href=\\\"https://www.helponclick.com/privacy/\\\" target=\\\"_blank\\\">Privacy Policy</a>, <a style=\\\"color:blue;\\\" href=\\\"xxxxss\\\" target=\\\"_blank\\\">d</a>\",\"value\":\"Yes\",\"type\":\"radio\"}}","system_msg":true,"screenSize":"1366X768","language":"en","staff_message":false,"visitorEnvironment":{"accountUid":null,"userUid":null,"ipAddress":"0:0:0:0:0:0:0:1","cc":null,"browser":"Firefox-78.0","os":"Windows","userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:78.0) Gecko/20100101 Firefox/78.0","screenSize":null,"refererUrl":null},"fileSize":""}],"disconnected":false}
     if(result.data){
       let chatMessages = result.data.allChatMsg;
       this.visitors[visitorId] = [];
       let operator_uid;
       for(let i in chatMessages){
     
        if (chatMessages[i].message.trim().length != 0 || (chatMessages[i].fileName != null && chatMessages[i].fileName != "")) { 
          
          if(chatMessages[i].chatStatus =="supervisionQuit"){
            chatMessages[i].system_msg = false; 
            chatMessages[i].staff_message =true;
          }
           
          chatMessages[i].type = chatMessages[i].role.toLowerCase() === "visitor" ? "inMsg" : "opsMsg";
         // alert(chatMessages[i].chatStatus+" "+chatMessages[i].system_msg+" "+chatMessages[i].staff_message)
          this.visitors[visitorId].push(chatMessages[i])
     
       }
        
       //if visitor has left the chat
       if(this.visitors[visitorId].length !=0 && chatMessages[i].chatStatus==="removeVisitor"){
           this.visitors[visitorId][0].visitorLeft = true;
        }

        //if visitor came back 
        if(this.visitors[visitorId].length !=0 && this.visitors[visitorId][0].visitorLeft && chatMessages[i].chatStatus==="chat")
           this.visitors[visitorId][0].visitorLeft = false;

       }

     }  
    }).catch((error) => {
       //this.logout();
    });

    
  }

     getCurrentOngoingChats = async () =>{

      //get ongoing chats on refresh from redis 
      await axios({ method: 'GET', url: this.url + 'getallOngoingchat.json',
        headers: { 'content-type': 'application/json' },
      
      }).then(result => {
        if(result.data.length==1){
          if(result.data[0].logoutstatus==1){
            this.logout();
          }
          }
        let allchats = result.data;
        this.maxconcurrentchats=allchats.length;
        this.visitors={};
       
        for(let i in allchats){
          this.visitors[allchats[i].csId]=[];

          const widget_Websiteuid = {
            "assist_uid" : allchats[i].allChatMsg[0].assist_uid,
            "websiteUid": allchats[i].allChatMsg[0].websiteUid} ;
      
          //this.updateWebsite_wigdet_activeStatus(widget_Websiteuid , "remove"); 

          for(let j in allchats[i].allChatMsg){

            if (allchats[i].allChatMsg[j].message && allchats[i].allChatMsg[j].message.trim().length != 0 || (allchats[i].allChatMsg[j].fileName != null && allchats[i].allChatMsg[j].fileName != "")) { 
              
              //  if(allchats[i].allChatMsg[j].chatStatus =="supervisionQuit"){
              //    allchats[i].allChatMsg[j].system_msg = false; 
              //    allchats[i].allChatMsg[j].staff_message =true;
              //  }
               allchats[i].allChatMsg[j].type = allchats[i].allChatMsg[j].role.toLowerCase() === "visitor" ? "inMsg" : "opsMsg";
               this.visitors[allchats[i].csId].push(allchats[i].allChatMsg[j])
          
            }
             
            //if visitor has left the chat
            if(this.visitors[allchats[i].csId].length !=0  && allchats[i].allChatMsg[j].chatStatus==="removeVisitor"){
              this.visitors[allchats[i].csId][0].visitorLeft = true;
             }

             //if visitor came back 
             if(this.visitors[allchats[i].csId].length !=0 && this.visitors[allchats[i].csId][0].visitorLeft && allchats[i].allChatMsg[j].chatStatus==="chat")
             this.visitors[allchats[i].csId][0].visitorLeft = false;

          }                  
        }
        
        this.visitorList =[];
        
        for(let i in this.visitors ){
           this.visitorList.push(this.visitors[i][0]);
        } 
       
        //set one selected visitor
        this.requestedVisitorId = allchats.length !=0 ? allchats[0].csId :"";
      })
      .catch(err => {
        //this.logout();
      })
    }
    continueOngoingChats = async () =>{
      await axios({ method: 'GET', url: this.url + 'getOngoingchatContinue.json',
        headers: { 'content-type': 'application/json' },
      
      }).then(result => {
        if(result.data.length==1){
          if(result.data[0].logoutstatus==1){
            this.logout();
          }
          }
        let allchats = result.data;
        this.maxconcurrentchats=allchats.length;
        this.visitors={};
       var chat_status=0; 
        for(let i in allchats){
          this.visitors[allchats[i].csId]=[];

          const widget_Websiteuid = {
            "assist_uid" : allchats[i].allChatMsg[0].assist_uid,
            "websiteUid": allchats[i].allChatMsg[0].websiteUid} ;
      
          for(let j in allchats[i].allChatMsg){

            if (allchats[i].allChatMsg[j].message && allchats[i].allChatMsg[j].message.trim().length != 0 || (allchats[i].allChatMsg[j].fileName != null && allchats[i].allChatMsg[j].fileName != "")) { 
              
               allchats[i].allChatMsg[j].type = allchats[i].allChatMsg[j].role.toLowerCase() === "visitor" ? "inMsg" : "opsMsg";
               this.visitors[allchats[i].csId].push(allchats[i].allChatMsg[j])
          
            }
             
            //if visitor has left the chat
            if(this.visitors[allchats[i].csId].length !=0  && allchats[i].allChatMsg[j].chatStatus==="removeVisitor"){
              this.visitors[allchats[i].csId][0].visitorLeft = true;
             } 

             //if visitor came back 
             if(this.visitors[allchats[i].csId].length !=0 && this.visitors[allchats[i].csId][0].visitorLeft && allchats[i].allChatMsg[j].chatStatus==="chat")
             this.visitors[allchats[i].csId][0].visitorLeft = false;

          }                  
        }
        
        this.visitorList =[];
        
        for(let i in this.visitors ){
           this.visitorList.push(this.visitors[i][0]);
        } 
       
        //set one selected visitor
        this.requestedVisitorId = allchats.length !=0 ? allchats[0].csId :"";
         if(allchats.length !=0){
          setTimeout(() => { 
            this.navigate('/chats/operator/1');  
           }, 100); 
           console.log("accept chat /chats/operator/1");
           setTimeout(() => { 
            this.navigate('/chats/operator/'+this.requestedVisitorId);  
            console.log("accept chat /chats/operator/"+this.requestedVisitorId);
           }, 105); 
         }
      })
      .catch(err => {
        //this.logout();
      })
    }

   

    acceptChatRequest= async(sourceStation) => {

       this.requestSoundRef.current.pause();

       this.lodasound=1; 
       soundManagerjs.soundManager.stopAll();

      //  let requestObj;
      // if(this.visitors[sourceStation]){ 
        
      //   for(let i= this.visitors[sourceStation].length -1; i>= 0 ; i--){
      //       if(this.visitors[sourceStation][i].chatStatus==="chatRequest"){
      //          requestObj = this.visitors[sourceStation][i];
      //          break;  
      //     }
      //    }
         
      //    // if((requestObj && requestObj.acceptedBy==="-2") || (requestObj && requestObj.transferredChat) || (requestObj && requestObj.invitedBy))
      //     //{
           
      //     //}
      // }
      console.log("accept chat start");
      for(let key in  this.chatRequests ){
        if(sourceStation===this.chatRequests[key][0].sourceStation){ 
            this.chatRequests[key][0].chatrequestAccepted=false;
        }
      }
       await this.getCurrenChat(sourceStation);
        
       console.log("getCurrenChat chat end");
       this.requestedVisitorId = sourceStation
       this.chatrequestAccepted= false;

       let requestObj;
        if(this.chatRequests[sourceStation]){ 
           for(let i= this.chatRequests[sourceStation].length -1; i>= 0 ; i--){
              if(this.chatRequests[sourceStation][i].chatStatus==="chatRequest"){
                 requestObj = this.chatRequests[sourceStation][i];
                 break;  
            }
           }
           
           // if((requestObj && requestObj.acceptedBy==="-2") || (requestObj && requestObj.transferredChat) || (requestObj && requestObj.invitedBy))
            //{
             
            //}
        }

       const currentTime =  this.getcurrentUtcTime();
       const user = this.userInfo.usersmodel;
       const userRole = user.user_type_id == 3 ? 'admin':'operator';
       const userProfileImg = user.image ? this.resourceurl+this.userInfo.accountsmodel.account_uid+'/'+user.image:'';
       const transferredChat = requestObj ? requestObj.transferredChat : false; 
       let inviteTojoin = false;
       let invitedBy = "";
      
       let opMsg = {transferredChat:transferredChat,system_msg:true,userUid:this.requestedVisitorId,operatorUid:user.user_uid,creationTime:currentTime,role:userRole,account_uid:this.userInfo.accountsmodel.account_uid,
        acceptedBy:user.user_uid, message:user.nick_name+" enters the chat",fileName:userProfileImg,originalFileName:"",fileSize:"", hostname:'', 
        sourceStation:user.user_uid,chatStatus:"accepted", name:user.nick_name, inviteTojoin:inviteTojoin ,invitedBy:invitedBy,
        email:user.email,targetStation:'/topic/'+this.requestedVisitorId}

       if(requestObj && requestObj.inviteTojoin){
        
            inviteTojoin = requestObj ? requestObj.inviteTojoin : false; 
            invitedBy =  requestObj ? requestObj.invitedBy : "";
            let joinedOperators = requestObj.joinedOperators ? requestObj.joinedOperators :[];

        if(invitedBy){ 
            if(this.inviteJoinedByOp[sourceStation])
              this.inviteJoinedByOp[sourceStation]= [...[invitedBy],...joinedOperators];

            else{
              this.inviteJoinedByOp[sourceStation]=[];
              this.inviteJoinedByOp[sourceStation]= [...[invitedBy],...joinedOperators];
            }
          }
          //get unique array of op uids
          this.inviteJoinedByOp[sourceStation] = [...new Set(this.inviteJoinedByOp[sourceStation])]
        
            opMsg.inviteTojoin = true;
            opMsg.invitedBy = invitedBy;
            opMsg.chatStatus = "inviteJoined";
            // send enter msg
            opMsg.sourceStation = this.requestedVisitorId;

            for(let j=0; j< this.inviteJoinedByOp[sourceStation].length; j++){
              opMsg.targetStation = '/topic/' + this.inviteJoinedByOp[sourceStation][j];
              this.clientRef.sendMessage("/app/op2op", JSON.stringify(opMsg))
            }
            
            opMsg.inviteTojoin = true;
            opMsg.invitedBy = invitedBy;
            opMsg.chatStatus = "accepted";
            opMsg.targetStation = '/topic/' + this.requestedVisitorId;
            opMsg.sourceStation = user.user_uid;
          
       }
       
       this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg)); 
     
      // this.visitorList =[];
      var stationexists=0;
      for(let i in  this.visitorList){
        if(this.visitorList[i].sourceStation===sourceStation){
          stationexists=1
        }

        if(stationexists==1)
        break;

      } 
       for(let key in  this.visitors ){
         try{
         if(sourceStation===this.visitors[key][0].sourceStation){      
          if(stationexists==0)
          this.visitorList.push(this.visitors[key][0]);

          //this.visitors[key][0].chatrequestAccepted=false;
         }
        }catch(errror){

        }        
       } 
       
      //  for(let key in  this.chatRequests ){
      //     if(sourceStation===this.chatRequests[key][0].sourceStation){ 
      //         this.chatRequests[key][0].chatrequestAccepted=false;
      //     }
      //   }
      try{
      this.acceptedvistorlist.push(this.requestedVisitorId);
      }catch(er){
      }
        this.navigate('/traffic');
        //this.navigate('/chats/operator/1');
        setTimeout(() => { 
          this.navigate('/chats/operator/1');  
         }, 100); 
        //  console.log("accept chat /chats/operator/1");
         setTimeout(() => { 
          this.navigate('/chats/operator/'+this.requestedVisitorId);  
          console.log("accept chat /chats/operator/"+this.requestedVisitorId);
         }, 105); 
       
       
         //store visitor id in session 
          const visitorId = this.requestedVisitorId; 
          axios.post(this.url+'storeacceptedVisitor.json?visitorid='+visitorId).catch(err=>{
            //this.logout();
          })
         
          //update active status of website and widget
           if(requestObj){
            requestObj.activeStatus = "active";
            this.updateActiveWebsite_widget(requestObj);
          }
          console.log("accept chat end");
           let concurrent_chatscount= await this.checkconcurrent_chats();  
           let update_op_stats = this.update_op_stats(user.user_uid,this.userInfo.accountsmodel.account_id,visitorId)
    }

    update_op_stats = (user_uid,account_uid,visitorId) =>{ 
      const data = {"type":"chat_missed","str":user_uid,"account_id":account_uid,"sourceStation":visitorId};
      axios.post(this.url + 'update_op_stats.json?str='+user_uid+'&account_id='+account_uid+'&sourceStation='+visitorId).catch(err=>{
          //this.logout();
        })
     
    }

    checkconcurrent_chats = async () =>{
      let maxchatcount=0;
      await axios.post(this.url+'getacceptedVisitor.json')
      .then(result => { 
       
        this.maxconcurrentchats=result.data; 
          //maxchatcount=result.data; 
        })
      .catch((error) => {  
        // this.logout();
      });
     
    }

    updateActiveWebsite_widget = (msgObj)=>{
      
      axios({
        method: 'POST',
        url: this.url + 'updateActiveWebsiteWidget.json',
        headers: { 'content-type': 'application/json' },
        data: msgObj,
      }).catch(err => {
        // this.logout()
      })
    }


    rejectChatRequest=(visitor) => {
       visitor.chatrequestAccepted=false;
       this.chatrequestAccepted = false;
       this.requestSoundRef.current.pause();
       this.lodasound=1;
       soundManagerjs.soundManager.stopAll();
       const user = this.userInfo.usersmodel;
       const currentTime = this.getcurrentUtcTime();

        let opMsg = {
          id: '', type: "", role:"operator",userUid: visitor.sourceStation, operatorUid:user.user_uid,  message: "",
          creationTime: currentTime, hostname: 'ip', sourceStation: visitor.sourceStation, chatStatus: "chatRejected",
          account_uid:user.account_uid, name: user.nick_name, email: user.email
          , fileName: "", originalFileName: "",fileSize:"", targetStation: '/topic/' + visitor.sourceStation
      }
     
       this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg));
    }
    
    async handleTrafficMonitorData(msg , ajaxCall){
     // console.log(msg.chatStatus);

      if(msg.chatStatus==="logoutOp" || msg.staff_message || (msg.role !="visitor" && msg.chatStatus !=="chatted") || msg.chatStatus ==="op_typing" || msg.chatStatus ==="typing" || msg.chatStatus ==="chatMissed")
      return;

      else if(msg.chatStatus === "online" || msg.chatStatus === "offline")
       return;

      if(msg.chatStatus.toLowerCase() === "browsing"){
        //store visitor id in session
        axios({method: 'POST', url: this.url + 'storetrafficvisitors.json?visitorId='+msg.sourceStation, 
         headers: { 'content-type': 'application/json' } })
        .then(result => {  
          this.global_errorcount=0;
        })
        .catch(err=>{
            console.log(err);
            console.log("error count :"+this.global_errorcount);
          //this.logout()
          this.global_errorcount=this.global_errorcount+1;
          if(this.global_errorcount>20){
           // this.logout();
          }
        });

        if(this.soundon_off)
        this.getplaySound(msg.websiteUid,'new_visitor')

      }

      //get address location of visitors
      var ipaddress="";
      if(msg.visitorEnvironment!=null && msg.visitorEnvironment.ipAddress!=null){
          ipaddress =  msg.visitorEnvironment.ipAddress; 
      }
      this.geoApiaddress = null;
      //ipaddress="103.252.25.101";
      //await this.getAddressforIp(ipaddress); 

      if(msg.chatStatus === "chatted")
      {
        var currenttime=this.getcurrentUtcTime();
        var creationtime=msg.creationTime+310;
        if(creationtime<=currenttime){
          this.removeFromTraffic([msg.sourceStation]);
          this.trafficVisitorStatus = this.trafficVisitorStatus.filter((obj)=> obj.sourceStation != msg.sourceStation )
            this.trafficVisitorStatusChanged = Math.random();
           
            this.activetrafficIndex =  this.trafficVisitorStatus.length;
            this.trafficVisitorStatus.map(function(data,dataIndex) {
              data.collapsed = true;
            });
            return;
        }
      }
      if(msg.chatStatus === "Browsing" || msg.chatStatus ==="Returned" || msg.chatStatus ==="Auto-invited" || msg.chatStatus ==="Refused invitation")
      {
        var currenttime=this.getcurrentUtcTime();
        var creationtime=msg.creationTime+310;
        if(creationtime<=currenttime){
          this.removeFromTraffic([msg.sourceStation]);
          this.trafficVisitorStatus = this.trafficVisitorStatus.filter((obj)=> obj.sourceStation != msg.sourceStation )
            this.trafficVisitorStatusChanged = Math.random();
           
            this.activetrafficIndex =  this.trafficVisitorStatus.length;
            this.trafficVisitorStatus.map(function(data,dataIndex) {
              data.collapsed = true;
            });
            return;
        }
      } 

       let setcomplete= await this.settingtrafficVisitorStatus(msg,ajaxCall,ipaddress);

              // console.log(this.trafficVisitorStatus);
        this.activetrafficIndex =  this.trafficVisitorStatus.length;
        this.trafficVisitorStatusChanged = Math.random();
        this.trafficVisitorStatus.map(function(data,dataIndex) {
          data.collapsed = true;
        });
        if(msg.chatStatus==="hideVisitor" || msg.chatStatus==="removeVisitor"){
          setTimeout(()=>{
            
            this.trafficVisitorStatus = this.trafficVisitorStatus.filter((obj)=> obj.sourceStation != msg.sourceStation )
            this.trafficVisitorStatusChanged = Math.random();
           
            this.activetrafficIndex =  this.trafficVisitorStatus.length;
            this.trafficVisitorStatus.map(function(data,dataIndex) {
              data.collapsed = true;
            });
          },100);   //5min 3sec
        }

        if(msg.chatStatus === "chatted")
        {
          setTimeout(()=>{
            
            this.trafficVisitorStatus = this.trafficVisitorStatus.filter((obj)=> obj.sourceStation != msg.sourceStation )
            this.trafficVisitorStatusChanged = Math.random();
           
            this.activetrafficIndex =  this.trafficVisitorStatus.length;
            this.trafficVisitorStatus.map(function(data,dataIndex) {
              data.collapsed = true;
            });
          },303000);   //5min 3sec
        }
    }

    settingtrafficVisitorStatus = async (msg,ajaxCall,ipaddress)=>{
      let monitor = {
        "browser":"",
        "page": "",
        "website": "",
        "time": "",
        "status": "",
        "creationTime":msg.creationTime,
        "expireTime":msg.creationTime+120,
        "address":this.geoApiaddress,
        "insupervision": false,
        "accepted":"",
        "child" :[],
        "op_invite":false
      }

      monitor.browser = msg.visitorEnvironment !=null ? msg.visitorEnvironment.browser :"";
      monitor.page = msg.pageTitle;
      monitor.website = msg.formUrl;
      monitor.acceptedBy = msg.acceptedBy
      monitor.sourceStation = msg.sourceStation;
      monitor.website_uid = msg.websiteUid;
      monitor.accepted = msg.acceptedBy;
      monitor.status = msg.chatStatus === "accepted" ? "chat" : msg.chatStatus;
      monitor.op_invite = msg.op_invite;
      if(msg.chatStatus==="chatRequest"){
        monitor.status = "Waiting in queue";
     }
      if(this.trafficVisitorStatus.length==0){
        await this.getAddressforIp(ipaddress);

           monitor.address=this.geoApiaddress;
           this.trafficVisitorStatus.push(monitor);
       }else{
        let sameVisitor= false;
        for(let i in  this.trafficVisitorStatus){
          // console.log(this.trafficVisitorStatus[i].sourceStation +"=="+msg.sourceStation);
          if(this.trafficVisitorStatus[i].sourceStation === msg.sourceStation){
             
            sameVisitor = true;
            //if(this.trafficVisitorStatus[i].status === "hideVisitor" || this.trafficVisitorStatus[i].status === "Returned" ||  this.trafficVisitorStatus[i].status==="removeVisitor"){
              if(this.trafficVisitorStatus[i].status === "hideVisitor" || this.trafficVisitorStatus[i].status === "Returned" ||  this.trafficVisitorStatus[i].status==="removeVisitor"){
              
              if(ajaxCall)
                 continue;

                if(this.trafficVisitorStatus[i].status === "Returned" && msg.chatStatus === "Returned")
                    //set time of first visit to avoid time updation on refresh
                     monitor.creationTime = this.trafficVisitorStatus[i].creationTime
                
                if(!msg.acceptedBy && msg.chatStatus !== "removeVisitor" && msg.chatStatus !=="hideVisitor" && this.trafficVisitorStatus[i].status != "chat"){
                
                    monitor.status = "Returned";
                  }
            }
            else{
              //set time of first visit to avoid time updation on refresh
              monitor.creationTime = this.trafficVisitorStatus[i].creationTime
            }

            if(msg.chatStatus === "removeVisitor"){
                  for(let j in this.trafficVisitorStatus){
                      if(this.trafficVisitorStatus[j].sourceStation === msg.sourceStation && this.trafficVisitorStatus[j].status != "chat"){
                       
                        if(this.trafficVisitorStatus[j].status=="chatted"){
                          monitor.status = "chatted";
                        }
                        else
                          this.trafficVisitorStatus[j].status = "hideVisitor";
                          
                          
                      }
                      else if(this.trafficVisitorStatus[j].sourceStation === msg.sourceStation && this.trafficVisitorStatus[j].status === "chat"){
                        monitor.acceptedBy = this.trafficVisitorStatus[j].acceptedBy;
                        monitor.status = "chat";
                      }
                  } 
                 this.handleVisitorLeft(msg); 
             } 
             if(msg.widget_loaded == true){
             monitor.child=this.trafficVisitorStatus[i].child;
             let childs=
             {"link": this.trafficVisitorStatus[i].website + "::" + this.trafficVisitorStatus[i].page,
               "page": this.trafficVisitorStatus[i].page,
              "time": this.trafficVisitorStatus[i].time,
              "status": this.trafficVisitorStatus[i].status};
              monitor.child.push(childs); 
             }else{
              monitor.child=this.trafficVisitorStatus[i].child;
             }
              this.trafficVisitorStatus[i]= monitor;
              
             
          
          }
        }

        if(!sameVisitor){ 
          await this.getAddressforIp(ipaddress);
          monitor.address=this.geoApiaddress;
          this.trafficVisitorStatus.push(monitor);
        }
       }

       return true;
    }

    getAllvisitorsEntrysOnRefresh= () =>{
      axios({method: 'GET', url: this.url + 'getalltrafficrecordFromRedis.json', headers: { 'content-type': 'application/json' } })
     .then(result => {  
       // console.log(result)
       let visitorData = result.data;
       
       if(visitorData){
           for(let i in visitorData){ 
             this.handleTrafficMonitorhistoryData(visitorData[i] , i);
           } 
           this.trafficVisitorStatusChanged = Math.random();
       } 
       this.global_errorcount=0;
     })
     .catch(error =>{
       //this.logout();
       console.log(error);
                  console.log("error count :"+this.global_errorcount);
                //this.logout()
                  this.global_errorcount=this.global_errorcount+1;
                  if(this.global_errorcount>20){
                  // this.logout();
                  }
     })
   }

    handleTrafficMonitorhistoryData(msg,sourceStation){
      // sourceStation 
      // for(let i in msg){
      //   console.log(msg[i]);
      //   console.log(this.trafficVisitorStatus.length);
      //   for(let j=0;j<this.trafficVisitorStatus.length;j++){
      //     console.log("this.trafficVisitorStatus[j].sourceStation === sourceStation");
      //     console.log(this.trafficVisitorStatus[j].sourceStation === sourceStation);
      //     if(this.trafficVisitorStatus[j].sourceStation === sourceStation){
      //       let childs=
      //       {"link": msg[i].formUrl + "::" + msg[i].pageTitle,
      //         "page":msg[i].pageTitle,
      //        "time": this.timeSpentByVisitor(msg[i]),
      //        "status": msg[i].chatStatus
      //       }; 
      //       this.trafficVisitorStatus[j].child.push(childs);
      //       }
      //     }
      //   }
        for(let j=0;j<this.trafficVisitorStatus.length;j++){
          if(this.trafficVisitorStatus[j].sourceStation === sourceStation){
            this.trafficVisitorStatus[j].child=[];
            let visitorentry_size=msg.length; 
          for(let i=0;i<msg.length-1;i++){        
              let childs=
              {"link": msg[i].formUrl + "::" + msg[i].pageTitle,
                "page":msg[i].pageTitle,
               "time": this.timeSpentByVisitor(msg[i],i,visitorentry_size,msg),
               "status": msg[i].chatStatus
              }; 
              this.trafficVisitorStatus[j].child.push(childs);
              }
          }
        } 
      }
      getcurrentUtc = () =>{
        //get current utc time with seconds
        let now = new Date();
        //return Math.floor((now.getTime() + (now.getTimezoneOffset() * 60000)));
        return Math.floor((now.getTime()));
      }  
      timeSpentByVisitor = (visitor,crrentindex,totalsize,data) =>{         
        let resolution;
        let EndTime = this.getcurrentUtc(); 
        let StartTime = visitor.creationTime*1000;
        if(crrentindex==0){
          EndTime=data[crrentindex+1].creationTime*1000;
          StartTime = visitor.creationTime*1000;
        }else{
          let addtime= (visitor.creationTime*1000) - (data[0].creationTime*1000)
          EndTime=(data[crrentindex+1].creationTime*1000)+addtime;
          StartTime = visitor.creationTime*1000;
        }
          
        
       
        resolution = EndTime - StartTime
        let totalSeconds = resolution / 1000;
       
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = (totalSeconds % 60).toFixed(0);
        
       if(hours == 0)
          return minutes+"m "+seconds+"s";
       else
          return hours +"hr "+ minutes+"m "+seconds+"s";
        
      }

    handleVisitorLeft =(msg) => {
     
      if(this.visitors[msg.sourceStation]){
          let chatObject = this.visitors[msg.sourceStation].find((obj)=> obj.chatStatus === "chat")
          // console.log(chatObject);
         
          if(chatObject){
          //means user was chatting and has close the tab, show status to Operator
          this.visitors[msg.sourceStation][0].visitorLeft = true;
       }
        
      }
      
    }

    setTrafficIndex(clickedRow,rowIndex) {
      //this.trafficVisitorSelected = {};
      this.trafficVisitorStatus.map(function(data,dataIndex) {
        if(rowIndex !== dataIndex) {
           data.collapsed = true;
        }
       })
      clickedRow.collapsed = !clickedRow.collapsed;
      if(!clickedRow.collapsed) {
        this.activetrafficIndex = rowIndex;
        this.rowLength = 1;
      }
      else{
        this.activetrafficIndex = this.trafficVisitorStatus.length;
        this.rowLength = 0;
      }
      let accounts_model=this.userInfo.accountsmodel;
      let invite_popup_enable=accounts_model.re_invitation==1 ? true : false; 

       this.trafficVisitorSelected = {
           "sourceStation":clickedRow.sourceStation,
           "accepted":clickedRow.acceptedBy ? true :false,
           "accepted_by":clickedRow.acceptedBy==""? "false":"true",
           "status":clickedRow.status,
           "op_invite":clickedRow.op_invite,
           "reinvite":invite_popup_enable,
           "accepted_opuid":clickedRow.acceptedBy
          };
    }
      getAddressforIp = async (ipAddress) => {
        //get response data for response  
        if(!ipAddress)
        return;

       this.geoApiaddress = null;
       
       await axios.get(this.url+'getgeodata.json?ipAddress='+ipAddress)
          .then(result => {

                    //get coordinates based on Ip address
                    if(result.data != null) {
                      result.data.countryDeatails = result.data.countryDeatails.replace("com.maxmind.geoip2.record.Country","");
                      result.data.countryDeatails = result.data.countryDeatails.trim();
                      result.data.countryDeatails = JSON.parse(result.data.countryDeatails);

                      result.data.iso_code = result.data.countryDeatails[0].iso_code.toLowerCase();
                      this.geoApiaddress = result.data;     
                    }else{
                      this.geoApiaddress = null;
                    }
          // console.log(this.geoApiaddress)
          this.global_errorcount=0;
          }).catch((error) => {
            // if (error.response) {
            //   this.logout();
              
            // }
            console.log(error);
                  console.log("error count :"+this.global_errorcount);
                //this.logout()
                  this.global_errorcount=this.global_errorcount+1;
                  if(this.global_errorcount>20){
                  // this.logout();
                  }
          });
        }
        getplaySound=(websiteuid,soundtype)=>{ 
          this.getuserSound(websiteuid,soundtype);
        }

        loopingsound =(mysound)=>{
          var mySound = soundManagerjs.soundManager.createSound({id: 'hhCymbal'+Math.random(),url: mysound});
          var self=this;
          //mySound.play();
          mySound.play({
            volume: 100,
            onfinish: function() {
              if(self.loopcountsound>0){
                self.loopcountsound=self.loopcountsound-1;
                self.loopingsound(mysound);
              }else{
                soundManagerjs.soundManager.stopAll();
              }
            }
          });  
        }
        playChattingSound = (sound, count,soundtype) => { 
          if(soundtype=="chat_request"){
            this.loopcountsound=count-1;
          }else{
            this.loopcountsound=0;
          }
          soundManagerjs.soundManager.stopAll();
          //this.loopcountsound=count;
          if(sound.charAt(0)=="."){
            sound = sound.substring(1);
           }
          this.loopingsound(this.soundurl+sound);
          //var mySound = soundManagerjs.soundManager.createSound({url: 'https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3',autoLoad: true,autoPlay: true});

         // mySound.play();

          return;
          //don't use downside code
          if(sound=="0")
          return;
 
          var audioElement = document.createElement('audio');
          audioElement.setAttribute("class","chat_requests_sounds");
          audioElement.setAttribute("preload","auto");
          audioElement.setAttribute('src', this.soundurl+sound);
            var loopcount=count;
            audioElement.addEventListener('ended', function () {
                // Wait 500 milliseconds before next loop
                
                setTimeout(function () {
                if(loopcount==count){
                    audioElement.play();
                    loopcount=loopcount+1;
                    }
                    else{
                    audioElement.pause();
                    } 
                  }, 500);
              }, false); 
            audioElement.play(); 
             
             var soundlearinterval= setInterval(() =>{
                if(this.lodasound!=0){
                  loopcount=count;
                audioElement.pause();
                clearInterval(soundlearinterval);
                }
              },500);
          }

//         playChattingSound = (sound, count,soundtype) => { 
//           if(sound=="0")
//           return;

//           this.soundPlaying = this.soundurl+sound; 
//         let self=this; 
//             if(soundtype=="chat_request"){ 
//               var times = count;
//               var timer=2; 
//               if(sound.indexOf("/static/media/sound1")!=-1){
//                 timer=times*13;
//               }
//               if(sound.indexOf("/static/media/sound2")!=-1){
//                 timer=times*17;
//               }
//               if(sound.indexOf("/static/media/sound3")!=-1){
//                 timer=times*8;
//               }
//               if(sound.indexOf("/static/media/sound4")!=-1){
//                 timer=times*5;
//               }
//               if(sound.indexOf("/static/media/sound5")!=-1){
//                 timer=times*6;
//               }
//               if(sound.indexOf("/static/media/default_sound")!=-1){
//                 timer=times*1;
//               }
//               setTimeout(function(){
//                 self.requestSoundRef.current.play(); 
//               },2); 
//             //console.log(timer);
//               setTimeout(function(){
//                 self.requestSoundRef.current.pause(); 
//               },timer*1000); 
              
//                 // var loop = setInterval(function(){
//                 //             times=times-1;
//                 //             if (times === 0) {
//                 //                 clearInterval(loop);
//                 //             }
 
//                 //             self.requestSoundRef.current.play(); 
                            
//                 //           }
//                 //           , 500);  
 
//               }else{ 
//                 //console.log("else"); 
//                 setTimeout(function(){
//                   self.requestSoundRef.current.play(); 
//                 },10); 

//                 setTimeout(function(){
//                   self.requestSoundRef.current.pause(); 
//                 },1*1000); 
//                // console.log(as);   
//               }
// }
 playSoundcheck= ()=> {
  this.requestSoundRef.current.play().then(response => {
    //console.log("successplay");
  }).catch(e => {
      console.log(e);    
  })
}
        
        getuserSound = (websiteuid,soundtype) => {  
          axios({
            method: 'POST',
            url: this.url + 'getUsersound.json',
            headers: { 'content-type': 'application/json' },
            data: { "website_uid": websiteuid }
          }).then(result => {
            // console.log(result.data); 
            let soundData = result.data
            if(result.data.length==1){
              if(result.data[0].logoutstatus==1){
                this.logout();
              }
            }
            if (result.data.length === 0) {
              this.getWebsiteSounds(websiteuid,soundtype);
            } else { 
              let loopcounter = 0;
              let packagesound = 0;
              var soundvalue = "";
              let match = 0;
              for (let index in soundData) {
                if (soundData[index].soundType == soundtype) {
                  packagesound = soundData[index].package_sound != "" ? soundData[index].package_sound : ''; 
                  let soundarray=[];
                  if(soundtype=="chat_request"){
                     soundarray=this.chat_request;
                  }else  if(soundtype=="message_received"){
                    soundarray=this.message_received;
                  }else  if(soundtype=="message_sent"){
                    soundarray=this.message_sent;
                  }else  if(soundtype=="new_visitor"){
                    soundarray=this.new_visitor;
                  } 
                  for (let i = 0; i < soundarray.length; i++) {
                    if (soundarray[i].index == packagesound) {
                      soundvalue = soundarray[i].value;
                      match = 1;
                    }
                    if (match == 1)
                      break;
                  }
                }
                if (match == 1)
                  break;
      
              }
              for (let index in soundData) {
                if (soundData[index].soundType == "loop_count") {
                  loopcounter = soundData[index].package_sound != "" ? soundData[index].package_sound : '';  
                  break;
                } 
              }
              this.playChattingSound(soundvalue, loopcounter,soundtype);
            }
            this.global_errorcount=0;
          }).catch((error) => {
           // this.logout();
            console.log(error);
                  console.log("error count :"+this.global_errorcount);
                //this.logout()
                  this.global_errorcount=this.global_errorcount+1;
                  if(this.global_errorcount>20){
                  // this.logout();
                  }
          })
      
        }
        getWebsiteSounds = (websiteUid,soundtype) => {   
          let websiteuid=websiteUid;
          axios({
            method: 'POST',
            url: this.url + 'getwebsitesound.json',
            headers: { 'content-type': 'application/json' },
            data: { "website_uid": websiteuid } 
          }).then(result => { 
            let soundData = result.data  
            if(result.data.length==1){
              if(result.data[0].logoutstatus==1){
                this.logout();
              }
            }
            if (result.data.length === 0) { 
              this.playChattingSound(imageURLs.chat_request1, 3,soundtype); 
            }else{ 
            let loopcounter=0;
            let packagesound=0;
            var soundvalue="";
            let match=0;
            for (let index in soundData) {
              if (soundData[index].soundType == soundtype) {
                packagesound = soundData[index].package_sound != "" ? soundData[index].package_sound : ''; 
                let soundarray=[];
                if(soundtype=="chat_request"){
                   soundarray=this.chat_request;
                }else  if(soundtype=="message_received"){
                  soundarray=this.message_received;
                }else  if(soundtype=="message_sent"){
                  soundarray=this.message_sent;
                }else  if(soundtype=="new_visitor"){
                  soundarray=this.new_visitor;
                } 
                  for (let i = 0; i < soundarray.length; i++) { 
                    if(soundarray[i].index == packagesound){ 
                      soundvalue=soundarray[i].value;
                      match=1;
                    }  
                    if(match==1)
                    break;
                  }
              }
              if(match==1)
              break; 
              
            } 
            for (let index in soundData) {
              if (soundData[index].soundType == "loop_count") {
                loopcounter = soundData[index].package_sound != "" ? soundData[index].package_sound : '';  
                break;
              } 
            } 
            this.playChattingSound(soundvalue, loopcounter,soundtype);
          }
          this.global_errorcount=0;
          }).catch((error) => { 

           // this.logout();
            console.log(error);
            console.log("error count :"+this.global_errorcount);
          //this.logout()
            this.global_errorcount=this.global_errorcount+1;
            if(this.global_errorcount>20){
            // this.logout();
            }
          })
       
        }
        
   transferChat(operator){
    //tranfer chat or invite operator to begin chat
    const user = operator;
    const currentTime = this.getcurrentUtcTime();
    let visitorReuestObj;
    if( this.requestedVisitorId){

      if(this.visitors[this.requestedVisitorId]){
         visitorReuestObj = this.visitors[this.requestedVisitorId].find(obj=> obj.chatStatus==="chatRequest")
      }
      else
         visitorReuestObj = undefined;     
    }

    if(!visitorReuestObj)
      return;

      let opMsg = visitorReuestObj;
      opMsg.targetStation = '/topic/'+user.id;
      opMsg.creationTime = currentTime;
      opMsg.transferredChat = true;
    // let opMsg =  {id:'',system_msg:true, role:"visitor", message:"enters the chat",creationTime: currentTime,hostname:'', 
    // operatorUid:user.id,prechatfields:prechatfields,sourceStation:visitor.sourceStation,chatStatus:"chatRequest", name:visitor.name, email:visitor.email
    // , targetStation:'/topic/'+user.id,websiteUid:visitor.websiteUid,visitorEnvironment :visitor.visitorEnvironment,screenSize:visitor.screenSize,
    // staff_message:false,ipAddress:visitor.ipAddress,account_uid:visitor.account_uid,formUrl:visitor.formUrl,pageTitle:visitor.pageTitle,
    // departmentUid:visitor.departmentUid,websiteUid:visitor.websiteUid,hostname:visitor.hostname,acceptedBy:""}

     this.clientRef.sendMessage("/app/opsmsg", JSON.stringify(opMsg)); 
     
    //  //quit chat with current visitor and set current chat different visitor if available
    //  if(Object.keys(this.visitors).length == 0 || Object.keys(this.visitors).length==1){
    //   this.requestedVisitorId = "";
    // }
    // else{
    //   let keys = Object.keys(this.visitors); //array of visitor id 
    //   this.requestedVisitorId = keys[0];
    // }
   }

   getcurrentUtcTime = ()=>{
    //get current utc time without seconds
    let now = new Date();
   // return Math.floor((now.getTime() + (now.getTimezoneOffset() * 60000))/1000);
   return Math.floor((now.getTime())/1000);
  }
  
  getLocalTime = (utcTimestamp) =>{
    //get converted current local time from utc time
    let now = new Date();
      //let cur = now.setTime(utcTimestamp*1000 - (now.getTimezoneOffset() * 60000));
      let cur = now.setTime(utcTimestamp*1000);
      let date = new Date(cur);
    
      //date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " +  
    return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
  }
  

  updateUserStatus(liveStatus){
    if(this.selectedWebisiteUid==undefined || this.selectedWebisiteUid=="" || this.selectedWebisiteUid==null)
        return;

    let user =  this.userInfo.usersmodel;
    const userstatus=user.user_live_status;
    user.user_live_status = liveStatus;
    this.userInfo.usersmodel.user_live_status=liveStatus;

     //send online,offline status to all Op
    // this.setofflineOnlineop(this.userInfo.alloperators,user,user.user_live_status);
    
    user.website_uid= this.selectedWebisiteUid;

    axios({
      method: 'POST',
      url: this.url + 'setonlineoffline.json',
      headers: { 'content-type': 'application/json' },
      data:user,
    }).then(result => {  
      if(result.data.length==1){
				if(result.data[0].logoutstatus==1){
				  this.logout();
				}
			  }
        let x;
        let index = 0;
        for (x in result.data) {
          if(result.data[x].user_uid === user.user_uid) {
            this.userInfo.usersmodel.userlivestatus = result.data[x].user_live_status;
            console.log(this.userInfo.usersmodel.userlivestatus);
            this.userlivestatus=result.data[x].user_live_status;
            this.loggedUserOnline = result.data[x].user_live_status == "online" ? true : false;
          }
          index++;
        }
        //this.userlivestatus=liveStatus;
        //this.loggedUserOnline =  liveStatus == "online" ? true : false
          // let x;
          // let index = 0;
          // for (x in result.data) {
          //   result.data[x].admin = result.data[x].user_type_id == 3 ? true : false;
          //   result.data[x].label = result.data[x].nick_name;
          //   result.data[x].value = index;
          //   result.data[x].isPasswordChanged = false;
          //   index++;
          // } 
          // this.operators=result.data;
          
          // for(let i=0; i< this.userInfo.alloperators.length; i++){
          //   if(this.userInfo.alloperators[i].user_uid === user.user_uid){
          //       this.userInfo.alloperators[i] =  user;
          //       break; 
          //     }
          // }

          //this.userStatus = itemStatus;
          this.global_errorcount=0;
        }).catch((error) => {
             // this.logout();    
             this.userlivestatus=userstatus;         
             user.user_live_status=userstatus;
              console.log(error);
            console.log("error count :"+this.global_errorcount);
          //this.logout()
            this.global_errorcount=this.global_errorcount+1;
            if(this.global_errorcount>20){
            // this.logout();
            }
        });      
     
   }   

   pingAction =()=>{
      axios.get(this.url+'pingAction.json?msg=ping')
      .then(result => { 
            if(result.data !=="pong"){

              const unsetData=true;
              this.logout(unsetData); 
              this.showSessionOverPopup = true;
            }
            this.global_errorcount=0
        })
      .catch((error) => {
       // this.logout();
        console.log(error);
        console.log("error count :"+this.global_errorcount);
      //this.logout()
        this.global_errorcount=this.global_errorcount+1;
        if(this.global_errorcount>20){
        // this.logout();
        }
      });
   }

   storetockendeviceid =()=>{
    var user = {
      platform:'web',
      deviceId: localStorage.getItem("firbasedevicetoken")
   }
    axios({
      method: 'POST',
      url: this.url + 'storetockenAction.json',
      headers: { 'content-type': 'application/json' },
      data:user,
    }).then(result => {  
      })
    .catch((error) => { 
    });
 }

   maxWebsiteCrossed= () =>{
		if(this.userInfo.accountplan.max_websites ==0)
			return false;
		else if( this.userInfo.allwebistes.length >= this.userInfo.accountplan.max_websites )
			return true;
		else
			return false;		
   }


  //  updateWebsite_wigdet_activeStatus = (msg,status) =>{
  //     let widgetcount = 1;
  //     let websitecount = 1;

  //     if(this.activeWidgets[msg.assist_uid]){
  //       widgetcount = this.activeWidgets[msg.assist_uid];
  //       widgetcount= status === "add" ? widgetcount + 1 : widgetcount - 1;
  //     }
       
  //     if(this.activeWebsites[msg.websiteUid]){
  //       websitecount = this.activeWebsites[msg.websiteUid];
  //       websitecount = status === "add" ? websitecount + 1 : websitecount - 1;
  //     }

  //     this.activeWidgets[msg.assist_uid] = widgetcount > 0 ? widgetcount :0;
  //     this.activeWebsites[msg.websiteUid] = websitecount > 0 ? websitecount :0;
  //  }
   
   getActiveWebsiteWidget =() => {
      return axios.get(this.url+'getActiveWebsiteWidget.json')
      
    }

   validateEmail = (email) => {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (reg.test(email) == false) 
      {
          //console.log('Invalid Email Address');
          return false;
      }

      return true;

}
updateclientConfigJson (clientConfigJsondata){
  axios({
    method: 'POST',
    url: this.url + 'updateclientConfigJson.json',
    headers: { 'content-type': 'application/json' },
    data:clientConfigJsondata,
  }).then(result => {  
    console.log(result);
    })
  .catch((error) => { 
  });
}
}
 decorate(AppStore, {
    	menuActive: observable,
    	toggleMenu: action,
        closeSubmenu: action,
        menuChanged: observable,
        selectedColor: observable,
        operatorMenuActive: observable,
        Config:observable,
        talkSessionUid:observable,
        visitorModel:observable,
        userInfo:observable,
        islogged:observable,
        isAdmin:observable,
        url:observable,
        localLanguage:observable,
        colorVal:observable,
        selectedLanguage:observable,
        chatautoInvitation:observable,
        selectedWebisiteUid:observable,
        addNewSite:observable,
        storedWidgets:observable,
        widgetForEdit:observable,
        deptOps:observable,
        resourceurl:observable,
        selectedtourStep:observable,
        componentDidUpdate:observable,
        customIconurl:observable,
        customImages:observable,
        imgpath:observable,
        helpTourStarted:observable,
        ownerEmail:observable,
        pageRefreshing:observable,
        isloggedout:observable,
        soundPlaying:observable,
        chatrequestAccepted:observable,
        visitors:observable,
        clientRef:observable,
        assignedTopics:observable,
        requestedVisitorId:observable,
        visitorList:observable,
        trafficMonitor:observable,
        trafficVisitorStatus:observable,
        activetrafficIndex:observable,
        visitorTotalSeconds:observable,
        trafficVisitorSelected:observable,
        visitorsTyping:observable,
        visitorTypingMsgChanged:observable,
        visitorName:observable,
        trafficVisitorStatusChanged:observable,
        supervisedBy:observable,
        loggedUserOnline:observable,
        operators:observable,
        dontLoadWidgets:observable,
        visitorChattingwithOps:observable,
        requestSoundRef:observable,
        soundurl:observable,
        chat_request:observable,
        message_received:observable,
        message_sent:observable,
        new_visitor:observable,
        soundon_off:observable,
        showSessionOverPopup:observable,
        geoApiaddress:observable,
        onlineSubmenuOperators:observable,
        autoLoggedOffCounter:observable,
        isAutoLoggedOff:observable,
        maxconcurrentchats:observable,
        chatisTransferred:observable,
        inviteJoinedByOp:observable,
        chatRequests:observable,
        currentChattingWebsite:observable,
        selectedWebisiteLogo:observable,
        selectedWebisitename:observable,
        tourcurrent_step:observable,
        editwebsite:observable,
        undersupervisionvistors:observable,
        pushpopp:observable,
        assistedit:observable,
        global_errorcount:observable,
        lodasound:observable,
        chatacceptalert:observable,
        acceptedvistorlist:observable,
        global_eventcount:observable,
        userlivestatus:observable,
        loopcountsound:observable,
        monthly_chat_enable_count:observable,
        deletesite:observable,
        deleteoperator:observable,
        deletedept:observable,
        deleteopt:observable,
        disableop:observable
    })
 export default AppStore;